import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FlexBox, Icon, IconButton, List, Timestamp, Tooltip, } from '@dixa/lib-shared-habla';
import { memo, useCallback } from 'react';
import { appActions } from 'app/app.actions';
import { getChannelName } from 'app/utils/channelName';
import { analytics } from 'app/utils/segment';
import { metaConversation } from 'components/conversation/utils/conversationObjectConverters';
import { ConversationDetails, ConversationDetailsLayout, } from 'components/conversationsOverview/components/ConversationDetails';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import styles from './timelineItemRow.module.scss';
export const TimelineItemRow = memo(function TimelineItemRow({ index, conversation, onConversationSelect, toggleDropdown, }) {
    const dispatch = useAppDispatch();
    const handlePreviewIconClick = useCallback((event) => {
        event.stopPropagation();
        dispatch(appActions.showModal({
            modal: {
                type: 'app:conversationPreview',
                arg: { csid: conversation.id },
            },
        }));
    }, [conversation, dispatch]);
    const metaConversationInstance = metaConversation.from.timelineItem(conversation);
    return (_jsx(List.Item, Object.assign({ isLink: true, className: styles.root, onClick: () => {
            if (conversation.id) {
                toggleDropdown();
                onConversationSelect(conversation.id);
                analytics.conversationTimelineNavigatedToConversation();
            }
        } }, { children: _jsxs(FlexBox, Object.assign({ alignItems: "center", justifyContent: "space-between", className: styles.wrapper }, { children: [_jsxs(FlexBox, Object.assign({ alignItems: "center", gap: "200" }, { children: [_jsx(Tooltip, Object.assign({ dark: true, content: "Preview" }, { children: _jsx(IconButton, { icon: "eye", variant: "tertiary", onClick: handlePreviewIconClick }) })), _jsx(ConversationDetails, { layout: ConversationDetailsLayout.ConversationTimeline, showRequesterAvatar: false, conversationName: null, metaConversation: metaConversationInstance, titleRenderer: () => conversation.title
                                ? conversation.title
                                : getChannelName(conversation.channel), subTitleRenderer: () => (_jsxs("span", { children: [_jsxs("span", { children: ["#", conversation.id] }), _jsx("span", { children: " . " }), _jsx(Timestamp, { time: conversation.date })] })) })] })), _jsx(Icon, { name: "angle-right" })] })) }), `${conversation.id}-${index}`));
});
